import {Col, Row} from "antd";
import {OrdersFilter} from "./filter";
import {StyledServiceOrderListHeaderTitle} from "./styles";

export function OrderListHeader() {
  return (
    <Row gutter={16} align="middle">
      <Col span={12}>
        <StyledServiceOrderListHeaderTitle>
          Customer orders
        </StyledServiceOrderListHeaderTitle>
      </Col>
      <Col span={12}>
        <OrdersFilter />
      </Col>
    </Row>
  );
}
